const version = sessionStorage.getItem('wl-ui-kit-react-select-version');
// const timezoneOffset = new Date().getTimezoneOffset();

// NOTE: Part 1/5: europe .. australia, -1 (+60) .. +10 (-600)
// const allowHostname =
//   location.hostname === 'localhost' || location.hostname.endsWith('.apptrium.cloud');
// const allowTimezone = timezoneOffset >= -600 && timezoneOffset <= 60;

// NOTE: Part 2/5: europe .. australia, -1 (+60) .. +10 (-600)
// const allowHostname = true;
// const allowTimezone = timezoneOffset >= -600 && timezoneOffset <= 60;

// NOTE: Part 3/5
// const allowHostname =
//   location.hostname === 'localhost' || location.hostname.endsWith('.apptrium.cloud');
// const allowTimezone = true;

// TODO: Part 4/5
const allowHostname = true;
const allowTimezone = true;

// TODO: Part 5/5: Drop react-select-v4 from @invent/wl-ui-kit

if (!version && allowHostname && allowTimezone) {
  sessionStorage.setItem('wl-ui-kit-react-select-version', 'v5');
}
